<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-location"></i> 地址列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="会员/收货人">
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入会员名或收货人"
              prefix-icon="el-icon-search"
              clearable
              class="search-input"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total">
            <i class="el-icon-location"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">总地址数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon users">
            <i class="el-icon-user"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ userCount }}</div>
            <div class="stat-label">覆盖用户</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon cities">
            <i class="el-icon-location-outline"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ cityCount }}</div>
            <div class="stat-label">覆盖城市</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          
          <el-table-column label="会员信息" min-width="150">
            <template slot-scope="scope">
              <div class="user-info">
                <div class="user-name">
                  <i class="el-icon-user"></i>
                  <span>{{ scope.row.user ? scope.row.user.user_name : '-' }}</span>
                </div>
                <div class="user-time" v-if="scope.row.add_time">
                  <i class="el-icon-time"></i>
                  <span>{{ scope.row.add_time | dateFormat }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="收货信息" min-width="200">
            <template slot-scope="scope">
              <div class="receiver-info">
                <div class="receiver-name">
                  <i class="el-icon-user-solid"></i>
                  <span>{{ scope.row.consignee || '-' }}</span>
                  <span class="phone">({{ scope.row.tel || '-' }})</span>
                </div>
                <div class="receiver-address">
                  <i class="el-icon-location"></i>
                  <span>{{ scope.row.address || '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="地址详情" min-width="280" prop="address">
            <template slot-scope="scope">
              <div class="address-detail">
                <span class="address-text">{{ scope.row.address || '-' }}</span>
                <el-tag 
                  v-if="scope.row.is_default" 
                  size="mini" 
                  type="success" 
                  effect="plain"
                  class="default-tag"
                >
                  默认
                </el-tag>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                class="detail-btn"
                @click="goInfo(scope.row)"
              >
                <i class="el-icon-view"></i> 详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-location-outline"></i>
        <p>暂无地址数据</p>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "addressList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        name: "",
      },
      
      // 统计数据
      userCount: 0,
      cityCount: 0,
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      showType: ''
    }
  },
  created() {
    this.DataList()
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return ""
      return moment(add_time * 1000).format("YYYY-MM-DD")
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() {
      return {
        cursor: 'pointer'
      }
    },
    
    // 计算统计数据
    calculateStats() {
      if (!this.tableLoadData || this.tableLoadData.length === 0) {
        this.userCount = 0
        this.cityCount = 0
        return
      }
      
      // 统计不重复的用户
      const uniqueUsers = new Set()
      const uniqueCities = new Set()
      
      this.tableLoadData.forEach(item => {
        if (item.user && item.user.user_name) {
          uniqueUsers.add(item.user.user_name)
        }
        if (item.address) {
          // 简单提取城市信息（可根据实际地址格式调整）
          const cityMatch = item.address.match(/省(.+?)市/);
          if (cityMatch && cityMatch[1]) {
            uniqueCities.add(cityMatch[1])
          }
        }
      })
      
      this.userCount = uniqueUsers.size
      this.cityCount = uniqueCities.size
    },
    
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    
    // 获取地址列表
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      
      if (this.searchForm.name) {
        param.keyword = this.searchForm.name
      }
      
      this.$axios.addressListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    // 跳转到地址详情（可关联订单）
    goInfo(row) {
      if (row.order_id) {
        this.$router.push({
          path: '/shopOrderInfo',
          query: { id: row.order_id }
        })
      } else {
        this.$message.info('暂无关联订单')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

// 面包屑样式
.breadcrumb-wrapper {
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
}

// 卡片样式
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .el-form-item {
    margin-bottom: 0;
  }
  
  .search-input {
    width: 280px;
  }
  
  .search-input .el-input__inner {
    border-radius: 20px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    border-radius: 20px;
    padding: 8px 20px;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}

// 统计卡片样式
.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  
  .stat-card {
    flex: 1;
    min-width: 160px;
    background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
    
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      
      &.total {
        background: linear-gradient(135deg, #1677ff, #4096ff);
      }
      
      &.users {
        background: linear-gradient(135deg, #00b578, #1acd8c);
      }
      
      &.cities {
        background: linear-gradient(135deg, #e6a23c, #ebb563);
      }
    }
    
    .stat-info {
      .stat-value {
        font-size: 28px;
        font-weight: 700;
        color: #1f2d3d;
        line-height: 1.2;
      }
      
      .stat-label {
        font-size: 13px;
        color: #8c8f98;
        margin-top: 4px;
      }
    }
  }
}

// 表格样式
.table-wrapper {
  margin-bottom: 20px;
  min-height: 350px;
}

.el-table {
  border-radius: 12px;
  overflow: hidden;
}

.el-table::before {
  display: none;
}

.el-table th {
  background: #fafbfc !important;
  font-weight: 500;
}

.el-table td {
  border-bottom: 1px solid #f0f0f0;
}

.el-table .el-table__row {
  transition: background 0.2s;
}

.el-table .el-table__row:hover {
  background: #f8f9fc;
}

// 用户信息样式
.user-info {
  .user-name {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
    
    i {
      color: #1677ff;
      font-size: 14px;
    }
    
    span {
      font-weight: 500;
    }
  }
  
  .user-time {
    display: flex;
    align-items: center;
    gap: 6px;
    
    i {
      color: #8c8f98;
      font-size: 12px;
    }
    
    span {
      font-size: 11px;
      color: #8c8f98;
    }
  }
}

// 收货信息样式
.receiver-info {
  .receiver-name {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
    
    i {
      color: #e6a23c;
      font-size: 14px;
    }
    
    span {
      font-weight: 500;
    }
    
    .phone {
      font-size: 12px;
      color: #8c8f98;
      font-weight: normal;
    }
  }
  
  .receiver-address {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    
    i {
      color: #909399;
      font-size: 12px;
      margin-top: 2px;
    }
    
    span {
      font-size: 12px;
      color: #606266;
      line-height: 1.4;
    }
  }
}

// 地址详情样式
.address-detail {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  
  .address-text {
    font-size: 13px;
    color: #1f2d3d;
    line-height: 1.4;
    flex: 1;
  }
  
  .default-tag {
    flex-shrink: 0;
  }
}

// 操作按钮样式
.detail-btn {
  color: #1677ff;
  
  i {
    margin-right: 4px;
  }
  
  &:hover {
    color: #4096ff;
  }
}

// 空状态样式
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
}

// 分页样式
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.el-pagination .el-pager li.active {
  background: #1677ff;
  color: #fff;
}

.el-pagination .el-pagination__total {
  color: #8c8f98;
}
</style>